import { render, staticRenderFns } from "./AnonAddy.vue?vue&type=template&id=31d7a56f&scoped=true&"
import script from "./AnonAddy.vue?vue&type=script&lang=js&"
export * from "./AnonAddy.vue?vue&type=script&lang=js&"
import style0 from "./AnonAddy.vue?vue&type=style&index=0&id=31d7a56f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d7a56f",
  null
  
)

export default component.exports